<template>
    <div class="block">
      <div class="text-center">
        <h4 class="popular-products-widget__title_400 text-u-c">Popular right now</h4>
        <div>
          <a v-if="marketplaceUrl" 
            :href="marketplaceUrl" 
            class="popular-products-widget__link" target="_blank">more > </a>
        </div>
      </div>
      <div class="products-grid row">
          <div @click="gotoProduct(product.id)" class="product-block" v-for="(product, i) of products" :key="i">
            <lazy-img v-if="product.primaryImage" :src="product.primaryImage.url"></lazy-img>
            <div class="product-block-name">{{product.name}}</div>
            <div class="product-prices">
              <div class="product-current-price" v-if="product.price">
                RM {{priceFormat(product.discount_price ? product.discount_price : product.price)}}
                <span class="product-unit">{{product.unit_of_measure ? '/' + product.unit_of_measure : ''}}</span>
              </div>
              <!--<div class="product-old-price" v-if="product.discount_price">-->
              <!--<span class="product-old-price-number">RM {{priceFormat(product.price)}}</span>-->
              <!--<span>({{calcOffDiscount(product.price, product.discount_price)}}-->
              <!--% off)</span>-->
              <!--</div>-->
            </div>
          </div>
      </div>

    </div>
</template>

<script>

    export default {
      name: "popular-products",
      data() {
        return {
          marketplaceUrl : window.marketplace.url
        }
      },
      props: {
        products: null
      },
      mounted() {
      },
      watch: {
        products: function (to) {
          this.products = to;
        }
      },
      methods: {
        calcOffDiscount(price, discount_price) {
          return 100 - Math.round((discount_price / price) * 100);
        },
        priceFormat(price) {
          return price.toLocaleString('en', {minimumFractionDigits: 2});
        },
        gotoProduct(id) {
          this.$router.push('../' + id);
          this.$router.go();
        }
      }
    }
</script>

<style lang="scss">
  .lazy-image-placeholder {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .primary-image .lazy-img {
    width: 100%;
  }
  .products-grid {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .product-block {
    display: block;
    width: 320px;
    margin: 10px 20px;
    padding: 6px;
    background-color: #fff;
    cursor: pointer;
  }

  @media (min-width: 767.98px) {
    .products-grid {
      align-items: start;
      justify-content: center;
      flex-direction: row;
    }
    .product-block {
      width: 220px;
    }
  }
  .product-block-name {
    text-align: center;
    padding: 16px 10px;
    min-height: 70px;
  }
  .product-prices {
    min-height: 30px;
    padding-bottom: 20px;
  }
  .product-current-price {
    font-weight: 500;
    font-size: 1rem;
  }
  .product-unit {
    font-weight: normal;
    font-size: .8rem;
    color: #888;
  }
  .product-old-price {
    font-weight: 300;
    font-size: .8rem;
    color: #888;
  }
  .product-old-price-number {
    text-decoration: line-through;
  }
  @media only screen and (min-width: 1200px){
    .popular-products-widget__title_400 {
      color: #444;
      font-size: 24px;
      font-weight: 400;
      line-height: 1.75rem;
    }
    .popular-products-widget__link {
      color: #777;
      font-size: 14px;
      font-weight: 400;
    }
    .product-block-name {
      color: #000;
      font-size: 16px;
    }
    .product-current-price {
      color: #333;
    }

  }
  @media only screen and (max-width: 1199px) and (min-width: 768px){
    .popular-products-widget__title_400 {
      color: #444;
      font-size: 24px;
      font-weight: 400;
      line-height: 1.75rem;
    }
    .popular-products-widget__link {
      color: #777;
      font-size: 14px;
      font-weight: 400;
    }
    .product-block-name {
      color: #000;
      font-size: 16px;
    }
    .product-current-price {
      color: #333;
    }

  }
  @media only screen and (max-width: 767px){
    .popular-products-widget__title_400 {
      color: #444;
      font-size: 24px;
      font-weight: 400;
      line-height: 1.75rem;
    }
    .popular-products-widget__link {
      color: #777;
      font-size: 14px;
      font-weight: 400;
    }
    .product-block-name {
      color: #000;
      font-size: 16px;
    }
    .product-current-price {
      color: #333;
    }

  }

</style>
